module.exports = __webpack_public_path__ + "img/24.679e280f.png";